import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Table from 'react-bootstrap/Table'
import TableFooter from 'shared/tables/table-footer'
import TableLoading from 'shared/tables/table-loading'
import MutedText from 'shared/forms/muted-text'
import { HighRiskPermissionBadge, SuperUserPermissionBadge } from 'shared/badges'
import { useRolePermissions } from 'api/hooks/use-role-permissions'
import Category from './category'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFolder } from '@fortawesome/free-solid-svg-icons'

// Filter state lives in show.jsx so the Actions dropdown export stays in
// sync with what this tab displays.
function PermissionsTab({ role, params, setParams }) {
  const { data, isSuccess, isLoading } = useRolePermissions({ params })

  return (
    <Card className="border">
      <Card.Header className="bg-white">
        <Row>
          <Col sm="auto">
            <div className="text-info">Permissions</div>
          </Col>
          <Col sm="auto">
            <Category
              params={params}
              setParams={setParams}
              categories={role.functional_categories}
            />
          </Col>

          <Col sm="auto">
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="show-non-zero-values"
                onChange={(e) =>
                  setParams({ ...params, is_expansive: e.target.checked })
                }
                checked={params.is_expansive}
              />
              <label className="form-check-label" for="show-non-zero-values">
                Expansive
              </label>
            </div>
          </Col>
          <Col sm="auto">
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="show-high-risk-only"
                onChange={(e) =>
                  setParams({ ...params, is_high_risk: e.target.checked })
                }
                checked={params.is_high_risk}
              />
              <label className="form-check-label" for="show-high-risk-only">
                High Risk
              </label>
            </div>
          </Col>
          <Col sm="auto">
            <div className="form-check form-switch ms-4">
              <input
                className="form-check-input"
                type="checkbox"
                id="show-super-only"
                onChange={(e) =>
                  setParams({ ...params, is_super_user: e.target.checked })
                }
                checked={params.is_super_user}
              />
              <label className="form-check-label" for="show-super-only">
                Super User
              </label>
            </div>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <Table responsive size="sm">
          <thead>
            <tr>
              <th>Category</th>
              <th>Permission</th>
              <th>Value</th>
              <th>Permission Code</th>
            </tr>
          </thead>
          <tbody>
            {isLoading && <TableLoading columns={4} />}
            {isSuccess &&
              data.data.map((rp) => (
                <tr key={`permissions-row-${rp.id}`}>
                  <td>
                    <MutedText as="div">
                      <FontAwesomeIcon
                        icon={faFolder}
                        className="text-muted me-2"
                      />
                      {rp.permission.category_caption}
                    </MutedText>
                  </td>
                  <td>
                    {rp.permission.description}

                    {rp.is_high_risk && (
                      <HighRiskPermissionBadge count={1} displayCount={false} />
                    )}
                    {rp.permission.is_superuser && (
                      <SuperUserPermissionBadge
                        count={1}
                        displayCount={false}
                      />
                    )}
                  </td>
                  <td>{rp.permission_value}</td>

                  <td>
                    <span className="ms-2 text-sm text-muted">
                      {rp.permission.name}
                    </span>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
        {isSuccess && (
          <TableFooter
            meta={data.meta}
            params={params}
            setParams={setParams}
            total={data.data.length}
          />
        )}
      </Card.Body>
    </Card>
  )
}

export default PermissionsTab
